import { Col, Row } from "reactstrap";
import BlogBoxDetails from "./BlogBoxDetails";
import BlogComments from "./BlogComments";
import LeaveYourComment from "./LeaveYourComment";

const BogBody = () => {
  return (
    <Col xxl="9" xl="8" className="box-col-12">
      <Row>
        <BlogBoxDetails />
        <BlogComments />
        <LeaveYourComment />
      </Row>
    </Col>
  );
};

export default BogBody;
